<template>
	<div>
		<div class="wd-p-20 wd-font-bold wd-font-18">修改支付密码</div>
		<div class="info wd-flex wd-row-left">
			<div class="wd-m-l-20 wd-width-percent-100">
				<div class="wd-flex wd-row-left level wd-m-t-20 wd-m-b-20">
					<div class="a" :class="levelflag === 0 ? 'select' : ''">
						1、验证身份
						<i class="jt"></i>
					</div>
					<div class="a" :class="levelflag === 1 ? 'select' : ''">
						2、设置支付密码
						<i class="jt"></i>
					</div>
					<div class="a" :class="levelflag === 2 ? 'select' : ''">3、修改完成</div>
				</div>
				<div class="form">
					<el-form label-width="140px">
						<div v-if="levelflag === 0">
							<el-form-item label="请选择验证方式:">
								<el-select placeholder="请选择" v-model="valtype"><el-option key="0" label="手机号验证" value="0"></el-option></el-select>
							</el-form-item>
							<el-form-item label="手机号码:">
								<span class="wd-font-18 wd-font-bold">{{ myinfo.mobile }}</span>
							</el-form-item>
							<el-form-item label="验证码:" class="">
								<div class="wd-flex wd-row-between">
									<el-input maxlength="18" type="text" v-model="valcode" minlength="6" placeholder="短信验证码"></el-input>
									<el-button class="wd-m-l-20" @click="sendvalcode" :disabled="smsdisabled">{{ smstext }}</el-button>
								</div>
							</el-form-item>
							<el-form-item><el-button type="primary" @click="save">下一步</el-button></el-form-item>
						</div>
						<div v-else-if="levelflag === 1">
							<el-form-item label="设置支付密码:">
								<el-input maxlength="6" type="password" v-model="pass1" minlength="6" placeholder="6位数字密码"></el-input>
							</el-form-item>
							<div class="wd-flex wd-row-left levelb wd-m-t-20 wd-m-b-20">
								<div class="a select">低</div>
								<div class="a">中</div>
								<div class="a">高</div>
							</div>
							<el-form-item label="确认支付密码:">
								<el-input maxlength="6" type="password" v-model="pass2" minlength="6" placeholder="6位数字密码"></el-input>
							</el-form-item>
							<el-form-item><el-button type="primary" @click="save">确认修改</el-button></el-form-item>
						</div>
						<div v-else-if="levelflag === 2">
							<div class="wd-m-50">支付密码设置成功！请牢记您设置的支付密码。</div>
							<div class="wd-flex wd-row-around">
								<el-button class="" type="primary" @click="wdopt('')">去首页</el-button>
								<el-button type="primary" @click="wdopt('cart')">去购物车</el-button>
							</div>
						</div>

						<div class="wd-theme-999 wd-m-t-20" v-if="levelflag === 1">
							<p>1.支付密码是购物卡或账户余额的支付凭证，建议不要与其他网站密码相同。</p>
							<p>2.定期修改支付密码能让账户资金更安全。</p>
						</div>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Paypassword',
	data() {
		return {
			pass1: '',
			pass2: '',
			valcode: '',
			levelflag: 0,
			levelname: '下一步',
			valtype: '0',
			myinfo: {},
			smsdisabled: false,
			smstext: '获取验证码',
			smstime: 0,
			timer: null
		};
	},
	methods: {
		cleartime() {
			clearInterval(this.timer);
			this.smsdisabled = false;
			this.smstext = '获取验证码';
		},
		sendvalcode() {
			if (!this.smsdisabled) {
				if (this.myinfo.mobile.length != 11) {
					this.$wd_toast('手机号不正确', 'error');
					return;
				}
				this.smsmobile = this.myinfo.mobile;
				this.smstime = 60;
				this.smsdisabled = true;
				let indata = {
					mobile: this.myinfo.mobile,
					type: 'reguser'
				};
				this.$wd_request('sendsms', indata).then(data => {
					this.$wd_toast(data.msg);
				});
				//发送
				this.timer = setInterval(() => {
					this.smstime--;
					this.smstext = this.smstime + '秒再获取';
					if (this.smstime < 0) {
						this.cleartime();
						return;
					}
				}, 1000);
			}
		},
		wdopt(type) {
			if (type === 'cart') {
				this.$router.push('Cart');
			} else {
				this.$router.push('/');
			}
		},
		save() {
			if (this.levelflag === 0) {
				this.levelflag = 1;
			} else if (this.levelflag === 1) {
				if (this.pass1.length !== 6) {
					this.$wd_toast('密码必须是6位数字', 'error');
					return;
				}
				if (this.pass1 !== this.pass2) {
					this.$wd_toast('两次密码输入不一致!', 'error');
					return;
				}
				var reg = /^\d{6}\b/;
				if (!reg.test(this.pass1)) {
					this.$wd_toast('密码必须是6位数字', 'error');
					return;
				}
				this.$wd_request('editmeminfo', { mobile: this.myinfo.mobile, act: 'paypasswordbymobile', value: this.pass1, value2: this.pass2 })
					.then(() => {
						this.levelflag = 2;
					})
					.catch(data => {
						this.$wd_toast(data.msg, 'error');
					});
			} else if (this.levelflag === 2) {
				console.log('a');
			}
		},
		loaddata() {
			this.$wd_request('meminfo', {}, true, '.memdetail')
				.then(data => {
					this.myinfo = data.value;
				})
				.catch(data => {
					this.$wd_toast(data.msg, 'error');
				});
		}
	},
	activated() {
		this.loaddata();
	},
	created() {
		this.loaddata();
	}
};
</script>

<style lang="scss" scoped>
.levelb {
	margin-left: 140px;
	.a {
		padding: 2px 20px;
		background: #dddddd;
		color: white;
		margin-right: 5px;
		&.select {
			background: $wd-theme;
		}
	}
}
.info {
	width: 100%;
	.level {
		.a {
			width: 33.33333%;
			height: 33px;
			background: #eeeeee;
			float: left;
			font-size: 16px;
			line-height: 33px;
			color: #333333;
			text-align: center;
			position: relative;
			.jt {
				background: url(../../../assets/jt.png) no-repeat;
				height: 33px;
				width: 19px;
				position: absolute;
				right: -9px;
				z-index: 9;
			}
			&.select {
				background: #fff4d8;
				color: #ff8401;
			}
		}
	}
	.form {
		width: 400px;
		margin: auto;
		margin-top: 40px;
	}
}
</style>
